import React from 'react'
import Bugs from '../../pages-partial/BugReport'

const BugReport = () => {
  return (
    <div><Bugs /></div>
  )
}

export default BugReport